function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DelimitedTextFormatter } from 'field-kit';
// In UK postal codes, the second part of the postal code is required and always 3 characters.
const INNER_CODE_LENGTH = 3;
export default class GBPostalCodeFormatter extends DelimitedTextFormatter {
  constructor() {
    super(' ', true);
    _defineProperty(this, "delimiterIndex", 2);
    this.maximumLength = 8;
  }
  /**
   * UK postal codes are formatted as
   * SWE1 1AB
   * The first second is the outer code and the second is the inner code. The inner
   * code is required to be 3 characters in length. Using this knowledge, we will set
   * the delimiters based on the length of the outer code.
   */
  _setDelimiterIndex(str) {
    const outerLength = str.length - INNER_CODE_LENGTH;
    if (outerLength === 4) {
      this.delimiterIndex = 4;
    } else if (outerLength === 3) {
      this.delimiterIndex = 3;
    } else {
      this.delimiterIndex = 2;
    }
  }
  format(str) {
    const withoutSpace = str.replace(/\s/g, '');
    this._setDelimiterIndex(withoutSpace);
    return super.format(withoutSpace);
  }
  hasDelimiterAtIndex(index) {
    return index === this.delimiterIndex;
  }
  isChangeValid(change, error) {
    const withoutSpace = change.proposed.text.replace(/\s/g, '');
    if (/^\w*$/.test(withoutSpace) && withoutSpace.length < 8) {
      this._setDelimiterIndex(withoutSpace);
      change.proposed.text = withoutSpace;
      return super.isChangeValid(change, error);
    }
    return false;
  }
}